module.exports = __webpack_public_path__ + "static/media/vakker.2e8723c0.m4a";